import * as React from 'react'
import FilterIcon from './FilterIcon'
import { FilterBody } from './FilterBody'
import { isNumeric } from '../../Utils/isNumeric'
import { useOnCloseElement } from '../../Effects/useOnCloseElement'

// type TextFilterProps = {
//     value: string,
//     onSubmit: (value: string) => void
// }
// type TextFilterState = {
//     value:string,
//     isOpen:boolean,
// }
interface Props {
    onSubmit: (value: string) => void
    value: string
}
interface State {
    isOpen: boolean
    value: string
}
const TextNumberFilter = (props: Props) => {
    const [isOpen, setIsOpen] = React.useState(false)
    const [value, setValue] = React.useState('')

    const searchInput = React.useRef<HTMLInputElement>()
    // constructor(props: Props) {
    //     super(props)
    //     this.searchInput = React.createRef()
    // }
    React.useEffect(() => {
        if (props.value != value) {
            setValue(props.value)
        }
    })
    React.useEffect(() => {
        if (isOpen && searchInput && searchInput && searchInput.current) {
            searchInput.current.focus()
            searchInput.current.select()
        }
    }, [isOpen])
    // componentDidUpdate(prevProps: Props, prevState: State) {
    //     if (!prevState.isOpen && this.state.isOpen) {
    //         if (this.searchInput && this.searchInput.current) {
    //             this.searchInput.current.focus()
    //             this.searchInput.current.select()
    //         }
    //     }
    // }
    const close = () => {
        setIsOpen(false)
    }
    const clear = () => {
        setValue('')
    }
    const ref = React.useRef()
    useOnCloseElement(ref, close)
    const onSubmit = () => {
        props.onSubmit(value)
        close()
    }

    const onChange = (e: any) => {
        const newValue = e.target.value
        if (isNumeric(newValue) || newValue == '') {
            setValue(e.target.value)
        }
    }
    const keyPressed = (event: any) => {
        switch (event.keyCode) {
            case 27:
                close()
                break
            case 13:
                onSubmit()
                break
            default:
                break
        }
    }
    return (
        <div ref={ref as any} className="data-table-filter">
            <FilterIcon
                title={props.value}
                isActive={props.value.length > 0}
                isOpen={isOpen}
                onClick={() => {
                    setIsOpen(!isOpen)
                    setValue(props.value)
                }}
            />
            {isOpen && (
                <FilterBody onClose={close}>
                    <input ref={searchInput as any} value={value} onKeyDown={keyPressed} onChange={onChange} />
                    <i className="data-table-filter-clear" onClick={clear}></i>
                    <button onClick={onSubmit} className="data-table-filter-add-button">
                        Submit
                    </button>
                    <div className="clear"></div>
                </FilterBody>
            )}
        </div>
    )
}
export default TextNumberFilter
